<template>
  <div class="xp-font xp-bg-mobile min-h-screen px-3 py-6">
    <div class="mx-auto flex max-w-2xl flex-col gap-5">
      <div class="flex items-center gap-3 text-white">
        <UserTile :size="52" />
        <div>
          <p class="text-lg font-bold drop-shadow-[1px_1px_2px_rgba(0,0,0,0.6)]">
            {{ t('hero.name') }}
          </p>
          <p class="font-mono text-[11px] text-white/70">{{ t('hero.aka') }}</p>
          <p class="font-mono text-xs text-white/85">{{ t('hero.role') }}</p>
        </div>
        <div class="ml-auto flex gap-1.5">
          <button
            v-for="loc in locales"
            :key="loc"
            class="rounded border border-white/40 px-2 py-1 text-xs text-white"
            :class="{ 'bg-white/25 font-bold': current === loc }"
            @click="switchLocale(loc)"
          >
            {{ loc === 'pt-BR' ? 'PT' : 'EN' }}
          </button>
          <button
            class="rounded border border-white/40 px-2 py-1 text-xs text-white"
            :class="{ 'bg-white/25 font-bold': crtEnabled }"
            :aria-pressed="crtEnabled"
            :title="t('xp.crt.label')"
            @click="toggleCrt"
          >
            📺
          </button>
        </div>
      </div>

      <XpWindow
        v-for="s in windows"
        :key="s.id"
        :title="s.title"
        :icon="s.glyph"
        :active="true"
        :minimized="false"
      >
        <component :is="s.component" />
      </XpWindow>

      <div class="xp-taskbar flex h-11 items-center justify-between px-3 text-white">
        <span class="xp-font text-sm italic"><span aria-hidden="true">❖</span> {{ t('xp.start') }}</span>
        <span class="xp-font text-xs">{{ t('contact.location') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import XpWindow from './XpWindow.vue'
import UserTile from './UserTile.vue'
import ProfileSection from '../sections/ProfileSection.vue'
import MetricsSection from '../sections/MetricsSection.vue'
import ExperienceSection from '../sections/ExperienceSection.vue'
import ProjectsSection from '../sections/ProjectsSection.vue'
import StackSection from '../sections/StackSection.vue'
import ContactSection from '../sections/ContactSection.vue'
import { setLocale, type Locale } from '../locales'
import { crtEnabled, toggleCrt } from '../composables/useCrt'

const { t, locale } = useI18n()
const locales: Locale[] = ['pt-BR', 'en']
const current = computed(() =>
  (locale.value as string).startsWith('pt') ? 'pt-BR' : 'en',
)

function switchLocale(loc: Locale): void {
  setLocale(loc)
}

const windows = computed(() => [
  { id: 'profile', title: t('xp.windows.profile.title'), glyph: '👤', component: ProfileSection },
  { id: 'metrics', title: t('xp.windows.metrics.title'), glyph: '📊', component: MetricsSection },
  { id: 'experience', title: t('xp.windows.experience.title'), glyph: '📝', component: ExperienceSection },
  { id: 'projects', title: t('xp.windows.projects.title'), glyph: '💻', component: ProjectsSection },
  { id: 'stack', title: t('xp.windows.stack.title'), glyph: '🎛️', component: StackSection },
  { id: 'contact', title: t('xp.windows.contact.title'), glyph: '✉️', component: ContactSection },
])
</script>
